module.exports = __webpack_public_path__ + "static/img/t3.e29b752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t3.png
// module id = YUPn
// module chunks = 1